import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Site } from 'src/app/utils/constants';
import { DataUser, PlanUser, UpdateClient } from 'src/app/utils/models';
import { environment } from 'src/environments/environment';
import { PublicDataService } from '../public-data/public-data.service';

@Injectable()
export class ProfileService {
  dataUser: DataUser;
  nickName: string;
  headers: any;
  planUser: PlanUser;
  servicesUser: number;

  constructor(
    private readonly http: HttpClient,
    private readonly PublicData: PublicDataService
  ) {
    this.dataUser = new DataUser();
    this.nickName = '';
    this.headers = null;
    this.planUser = new PlanUser();
    this.servicesUser = 0;
  }

  addCreditCard(text: string): Observable<any> {
    const body = {
      datos: text,
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };

    return this.http.post<any>(
      environment.api_pasarela_forma_pago.concat('RegistroFormaPagoGuardar'),
      body,
      this.headers
    );
  }

  deletePaymentMethod(idFormaPagoC: number): Observable<any> {
    const body = {
      idFormaPagoC,
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_pasarela_forma_pago.concat('eliminarTarjeta'),
      body,
      this.headers
    );
  }

  getCreditCards(): Observable<any> {
    const body = {
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };

    return this.http.post<any>(
      environment.api_pasarela_forma_pago.concat('ConsultarTarjetas'),
      body,
      this.headers
    );
  }

  getCreditCardDetailsById(cardId: number): Observable<any> {
    const body = {
      idFormaPagoC: Number(cardId),
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_pasarela_forma_pago.concat('ConsultarTarjetaDetalle'),
      body,
      this.headers
    );
  }

  getEncriptation(dato: string): Observable<any> {
    const body = {
      dato,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Encriptado/Encriptar'),
      body,
      this.headers
    );
  }

  getUserData(): Observable<any> {
    const body = {
      idUsuarioValor: this.dataUser.idUsuario,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/consultarGenerales'),
      body,
      this.headers
    );
  }

  getUserPayments(): Observable<any> {
    const body = {
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Transacciones/consultarPagos'),
      body,
      this.headers
    );
  }

  getUserPackage(): Observable<any> {
    const body = {
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/consultarPaquete'),
      body,
      this.headers
    );
  }

  getUserBalance(idPlan?: number): Observable<any> {
    const body = {
      idPaquete: idPlan ? idPlan : this.planUser.idPaquete,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/consultarSaldo'),
      body,
      this.headers
    );
  }

  updateClient(body: UpdateClient): Observable<any> {
    body.idioma = this.PublicData.idioma;
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Clientes/actualizarCliente'),
      body,
      this.headers
    );
  }

  updateProfile(body: any): Observable<any> {
    body.idioma = this.PublicData.idioma;
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/profileGuardar'),
      formData
    );
  }

  getPlans(): Observable<any> {
    const body = {
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/consultarPaquete'),
      body,
      this.headers
    );
  }

  getCharges(idPaquete: number): Observable<any> {
    const body = {
      idPaquete,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/usuarioCalcularCargos'),
      body,
      this.headers
    );
  }

  //Register payment paypal

  getPaypalAccounts(): Observable<any> {
    const body = {
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat(
        'api/Transacciones/consultarCuentasPayPal'
      ),
      body,
      this.headers
    );
  }

  setEncrypt(text: string): Observable<any> {
    const body = {
      dato: text,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Encriptado/Encriptar'),
      body,
      this.headers
    );
  }

  unsetEncrypt(text: string): Observable<any> {
    const body = {
      dato: text,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Encriptado/Desencriptar'),
      body,
      this.headers
    );
  }

  savePaymentMethod(text: string): Observable<any> {
    const body = {
      datos: text,
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_pasarela.concat(
        'api/Transacciones/registroFormaPagoGuardar'
      ),
      body,
      this.headers
    );
  }

  registerPurchase(text: string): Observable<any> {
    const body = {
      datos: text,
      idSitio: Site.siteId,
      idUsuario: this.dataUser.idUsuario,
      idioma: 'esp',
    };
    return this.http.post<any>(
      environment.api_pasarela.concat(
        'api/Transacciones/registroClientePagoPayPalGuardar'
      ),
      body,
      this.headers
    );
  }

  registerPurchaseInSite(text: string): Observable<any> {
    const body = {
      base64Text: text,
      idUsuario: this.dataUser.idUsuario,
      idioma: 'esp',
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/usuarioGeneraCargo'),
      body,
      this.headers
    );
  }

  getComboCountrys(): Observable<any> {
    const body = {
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/comboPais'),
      body,
      this.headers
    );
  }

  getComboStates(zipCode: string, idPais: number): Observable<any> {
    const body = {
      CP: zipCode,
      idPais,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/comboEntidades'),
      body,
      this.headers
    );
  }
  getComboCitys(zipCode: string, idEntidad: number): Observable<any> {
    const body = {
      CP: zipCode,
      idEntidad,
      idUsuario: this.dataUser.idUsuario,
      idioma: this.PublicData.idioma,
    };
    // console.log(body);

    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/comboMunicipios'),
      body,
      this.headers
    );
  }

  // API VIRTUALPLACE
  getTotalVisitasById(idUsuario: number): Observable<any> {
    return this.http.get<any>(
      environment.dashboard + `usuarios/visitas/total/${idUsuario}`
    );
  }
  getReportByIdTarjetaBy5Week(idUsuario: number): Observable<any> {
    return this.http.get<any>(
      environment.dashboard + `reportes/tarjetas?idUsuario=${idUsuario}`
    );
  }
}
